import { useState, useEffect } from 'react';
import store, { applicationActions } from '@apply/adminStore';
import { AppraisalsApi } from '@apply/api';
import { applicationInsights } from '../../../ApplicationInsights';
import { BfiDataGrid, Column } from '../../../common/SharedComponents';
import { GridSettingType } from '@apply/constants';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPencil } from '@fortawesome/free-solid-svg-icons';
import { useSelector } from 'react-redux';

const ReviewersTable = ({ gridStore }) => {
    const searchState = useSelector((state) => state.searchState);
    const appraisalsApi = new AppraisalsApi.AppraisalsApi(applicationInsights);
    const [dataStore, set_dataStore] = useState(gridStore?.store);
    const { dispatch } = store;

    const dataFunction = (criteria) => appraisalsApi.appraisalReviewersGrid(criteria);

    useEffect(() => {
        if (gridStore) {
            gridStore.setOnLoad('id', dataFunction, searchState?.searchText?.reviewer);
            set_dataStore(gridStore.store);
        }
    }, [gridStore]);

    const onCellDblClick = (e) => {
        dispatch(
            applicationActions.setEditReviewerModal({
                editReviewerModal: { isOpen: true, reviewerId: e.data.id },
            })
        );
    };

    const onIsDeletedRender = (e) => {
        return e.value ? 'No' : 'Yes';
    };

    const onActionCellRender = (e) => {
        return (
            <button
                id='editReviewer'
                className='gridButton'
                title='Edit current Reviewer'
                onClick={(event) => onCellDblClick(e)}
            >
                <FontAwesomeIcon icon={faPencil} />
            </button>
        );
    };

    return (
        <div className='card'>
            <div className='card-section'>
                <BfiDataGrid
                    gridType={GridSettingType.ApplicationReviewers}
                    dataStore={dataStore}
                    applicationInsights={applicationInsights}
                    onCellDblClick={onCellDblClick}
                >
                    <Column
                        dataField='firstName'
                        caption='First Name'
                        alignment='left'
                        width={200}
                    />
                    <Column
                        dataField='lastName'
                        caption='Last Name'
                        alignment='left'
                        width={200}
                    />
                    <Column
                        dataField='phone'
                        caption='Phone'
                        alignment='left'
                        width={150}
                    />
                    <Column
                        dataField='email'
                        caption='Email'
                        alignment='left'
                        width={300}
                    />
                    <Column
                        dataField='isDeleted'
                        caption='Active'
                        alignment='left'
                        cellRender={onIsDeletedRender}
                        width={80}
                    />
                    <Column
                        alignment='center'
                        cellRender={onActionCellRender}
                        width={50}
                        allowReordering={false}
                        allowSorting={false}
                        allowResizing={false}
                        type='actions'
                        fixed={true}
                        fixedPosition={'right'}
                    />
                </BfiDataGrid>
            </div>
        </div>
    );
};

export default ReviewersTable;
